import { JOB_STATUS, MAIN_APP_URL } from '../constants'

export const JOINABLE_STATUSES = ['Accepted', JOB_STATUS.IN_PROGRESS, JOB_STATUS.LONGJOB]
export const POLL_STATUSES = [JOB_STATUS.WAITING, JOB_STATUS.PENDING]
export const TERMINAL_DASHBOARD_STATUSES = [JOB_STATUS.DECLINED, JOB_STATUS.EXPIRED]

export function isValidJobId(jobId) {
	return typeof jobId === 'string' && jobId.trim() !== '' && jobId !== 'undefined' && jobId !== 'null'
}

export function wait(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms))
}

export function dashboardUrlForUserType(userType) {
	if (userType === 'technician') {
		return `${MAIN_APP_URL}/dashboard/technician`
	}
	return `${MAIN_APP_URL}/dashboard`
}

const CONFIRMED_NOT_FOUND_ATTEMPTS = 3

/**
 * Retry GET /job until a job document with an id is returned.
 * Transient failures (network, Unauthorised) keep retrying.
 * Consecutive JOB_NOT_FOUND / empty payloads stop after a few attempts.
 */
export async function fetchJobUntilFound(getJobInformation, jobId, cuId, isCancelled) {
	let delay = 1000
	let consecutiveNotFound = 0
	while (!isCancelled()) {
		const response = await getJobInformation(jobId, cuId)
		if (response && response.success && response.data && response.data.id) {
			return { job: response.data, notFound: false }
		}
		if (response && response.code === 'JOB_NOT_FOUND') {
			consecutiveNotFound += 1
			console.warn(`[Meeting] Job not found attempt ${consecutiveNotFound} for jobId: ${jobId}`)
			if (consecutiveNotFound >= CONFIRMED_NOT_FOUND_ATTEMPTS) {
				return { job: null, notFound: true }
			}
		} else {
			consecutiveNotFound = 0
			console.warn('[Meeting] getJobInformation retry:', response && response.message)
		}
		await wait(delay)
		delay = Math.min(Math.round(delay * 1.5), 5000)
	}
	return { job: null, notFound: false }
}

/**
 * Flip Accepted → Inprogress for the assigned technician or customer.
 * Idempotent when the job is already Inprogress.
 */
export async function ensureJobInProgress({
	jobInfo,
	userType,
	technicianJoinedMeeting,
	customerJoinedMeeting,
}) {
	if (!jobInfo || jobInfo.status !== 'Accepted') {
		return jobInfo
	}

	const JOIN_RETRIES = 3
	for (let attempt = 1; attempt <= JOIN_RETRIES; attempt++) {
		try {
			let joinResult = null
			if (userType === 'technician' && jobInfo.technician && jobInfo.technician.id) {
				joinResult = await technicianJoinedMeeting({
					jobId: jobInfo.id,
					technician: jobInfo.technician.id,
				})
			} else if (userType === 'customer' && jobInfo.customer && jobInfo.customer.id) {
				joinResult = await customerJoinedMeeting({
					jobId: jobInfo.id,
					customer: jobInfo.customer.id,
				})
			} else {
				return jobInfo
			}

			if (joinResult && (joinResult.transitioned || joinResult.status === JOB_STATUS.IN_PROGRESS)) {
				return { ...jobInfo, status: JOB_STATUS.IN_PROGRESS }
			}
		} catch (joinError) {
			console.error('[Meeting] Failed to mark job Inprogress on join:', joinError)
		}
		if (attempt < JOIN_RETRIES) {
			await wait(1000)
		}
	}

	return jobInfo
}
